import { render, staticRenderFns } from "./cmpfornecedoresproduto.vue?vue&type=template&id=e6d8214e&"
import script from "./cmpfornecedoresproduto.vue?vue&type=script&lang=js&"
export * from "./cmpfornecedoresproduto.vue?vue&type=script&lang=js&"
import style0 from "./cmpfornecedoresproduto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports